// eslint-disable-next-line
export default {
  // Auth
  "auth.login": "Login",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.enterEmail": "Enter your email",
  "auth.enterPassword": "Enter password",
  "auth.loginButton": "Sign In",
  "auth.loggingIn": "Signing in...",
  "auth.loginTitle": "Sign in to system",
  "auth.loginDescription": "Enter your email and password to sign in",
  "auth.logout": "Sign Out",
  "auth.authError": "Authentication error",
  // Common
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.create": "Create",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.yes": "Yes",
  "common.no": "No",
  "common.search": "Search",
  "common.filter": "Filter",
  "common.settings": "Settings",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.blocked": "Blocked",
  "common.total": "Total",
  "common.deleteUser": "Delete User",
  "common.resetPassword": "Reset Password",
  "common.confirmDelete": "Confirm Deletion",
  "common.deleteConfirmText": "Are you sure you want to delete this user? This action cannot be undone.",
  // Roles
  "role.admin": "Administrator",
  "role.teacher": "Teacher",
  "role.student": "Student",
  // Navigation
  "nav.dashboard": "Dashboard",
  "nav.users": "Users",
  "nav.students": "Students",
  "nav.teachers": "Teachers",
  "nav.courses": "Courses",
  "nav.schedule": "Schedule",
  "nav.grades": "Grades",
  "nav.last_entry": "Last entry",
  "nav.visits": "Visits",
  "nav.never": "Never",
  // Admin Dashboard
  "admin.title": "Administrator Panel",
  "admin.createTeacher": "Create Teacher",
  "admin.systemUsers": "System Users",
  "admin.userManagement": "User management for all system users",
  "admin.stats.admins": "Admins",
  "admin.stats.teachers": "Teachers",
  "admin.stats.students": "Students",
  "admin.block": "Block",
  "admin.unblock": "Unblock",
  // Teacher Dashboard
  "teacher.title": "Teacher Panel",
  "teacher.inviteStudent": "Invite Student",
  "teacher.myStudents": "My Students",
  "teacher.studentManagement": "Manage students in your groups",
  "teacher.noStudents": "You don't have any students yet",
  "teacher.inviteFirst": "Invite your first student by clicking the button above",
  "teacher.addedOn": "Added:",
  // Student Dashboard
  "student.title": "Student Dashboard",
  "student.personalInfo": "Personal Information",
  "student.yourData": "Your data in the system",
  "student.fullName": "Full Name",
  "student.role": "Role",
  "student.status": "Status",
  "student.courses": "Courses",
  "student.coursesDesc": "My courses and materials",
  "student.schedule": "Schedule",
  "student.scheduleDesc": "Class schedule",
  "student.grades": "Grades",
  "student.gradesDesc": "My grades and achievements",
  "student.notifications": "Notifications",
  "student.updates": "Latest updates and announcements",
  "student.welcome": "Welcome to the system!",
  "student.welcomeDesc": "You have been successfully registered in the school management system. Here you can view your courses, schedule and grades.",
  "student.today": "Today",
  "student.featuresInDev": "Features in development",
  "student.featuresDesc": "Additional features for students (courses, assignments, grades) will be added in future versions of the system.",
  "student.info": "Information",
  // Password Change
  "password.change": "Change Password",
  "password.new": "New Password",
  "password.confirm": "Confirm Password",
  "password.required": "You need to change the temporary password to continue",
  "password.enter": "Enter a new password for your account",
  "password.minLength": "Minimum 6 characters",
  "password.repeat": "Repeat new password",
  "password.saving": "Saving...",
  "password.success": "Password changed successfully",
  "password.error": "Error changing password",
  "password.minError": "Password must contain at least 6 characters",
  "password.mismatch": "Passwords do not match",
  // Create Teacher Modal
  "createTeacher.title": "Create Teacher",
  "createTeacher.description": "Enter the new teacher's details. An invitation will be sent to the specified email.",
  "createTeacher.fullName": "Full Name",
  "createTeacher.fullNamePlaceholder": "John Smith",
  "createTeacher.emailPlaceholder": "teacher@school.com",
  "createTeacher.creating": "Creating...",
  "createTeacher.success": "Teacher created successfully",
  "createTeacher.error": "Error creating teacher",
  "createTeacher.exists": "User with this email already exists",
  // Invite Student Modal
  "inviteStudent.title": "Invite Student",
  "inviteStudent.description": "Enter the new student's details. An invitation will be sent to the specified email.",
  "inviteStudent.fullName": "Full Name",
  "inviteStudent.fullNamePlaceholder": "John Smith",
  "inviteStudent.emailPlaceholder": "student@school.com",
  "inviteStudent.sending": "Sending invitation...",
  "inviteStudent.success": "Student invited successfully",
  "inviteStudent.error": "Error inviting student",
  // System
  "system.title": "Distance Learning System",
  "system.error": "System error",
  "system.networkError": "Network error",
  "system.unauthorized": "Unauthorized access",
  "system.forbidden": "Access denied",
  "system.notFound": "Not found",
  // Trainers
  "messages.userDeleted": "User deleted successfully",
  "messages.passwordReset": "Password reset and sent to email",
  "messages.deleteError": "Error deleting user",
  "messages.resetError": "Error resetting password",
  "training.start": "Start Training",
  "trainings.title": "Training Modules",
  "trainings.memory": "Memory Training",
  "trainings.memory.description": "Memory training exercises for students",
  "trainings.logic": "Logic Puzzles",
  "trainings.logic.description": "Logic puzzles and tasks for students",
  "trainings.back": "Back",
  "trainig.notImplemented": "This training module is not yet implemented",

  // Mental arithmetics
  "trainings.mental": "Mental Arithmetic",
  "trainings.mental.description": "Mental arithmetic training for students",

  "mentalArithmetic": "Mental Arithmetic",
  "trainer": "Trainer",
  "flashCards": "Flash Cards",
  "additionSubtraction": "Addition / Subtraction",
  "multiplicationDivision": "Multiplication / Division",
  "selectTrainerSettings": "Select trainer settings",
  "selectCardsSettings": "Select flash cards settings",
  "selectMultiSettings": "Select trainer settings",
  "go": "Go",
  "theme": "Theme",
  "difficulty": "Difficulty",
  "digits": "Digits",
  "actionsCount": "Number of actions",
  "inputTime": "Time for input",
  "speed": "Speed",
  "start": "Start",
  "stop": "Stop",
  "settings": "Settings",
  "continue": "Continue",
  "simple": "Simple",
  "brother": "Brother",
  "friend": "Friend",
  "friendBrother": "Friend + Brother",
  "transitions": "Transitions",
  "allThemes": "All themes",
  "multiplication": "Multiplication",
  "division": "Division",
  "squaring": "Squaring",
  "performExercise": "Perform exercise",
  "yourAnswer": "Your answer:",
  "correct": "Correct",
  "incorrect": "Incorrect",
  "answer": "Answer",
  "sec": "sec",
  "multiplier": "Multiplier",
  "divisor": "Divisor",
  "any": "Any",
  "multiplicationTable": "Multiplication table",
  "byMultiplicationTable": "By multiplication table",
  "resetAllSettings": "Reset all settings and reload page?",
  "difficulties": {
    "0-4": "0-4",
    "0-5": "0-5",
    "0-6": "0-6",
    "0-7": "0-7",
    "0-8": "0-8",
    "0-9": "0-9",
    "4": "4",
    "3": "3",
    "2": "2",
    "1": "1",
    "9": "9",
    "8": "8",
    "7": "7",
    "6": "6",
    "5": "5",
    "50Plus": "50 +",
    "50Minus": "50 -",
    "100Plus": "100 +",
    "100Minus": "100 -"
  },
  "multiDifficulties": {
    "multiplicationTable": "Multiplication table",
    "2x1": "II x I",
    "3x1": "III x I",
    "2x2": "II x II",
    "4x1": "IIII x I",
    "3x2": "III x II",
    "base50": "Base 50",
    "base100": "Base 100",
    "base200": "Base 200",
    "byMultiplicationTable": "By multiplication table",
    "2div1": "II / I",
    "3div1": "III / I",
    "4div1": "IIII / I",
    "2div2": "II / II",
    "3div2": "III / II",
    "4div2": "IIII / II",
    "4div3": "IIII / III",
    "2-10": "2-10",
    "on5": "by 5",
    "11-19": "11-19",
    "20-30": "20-30",
    "30-70": "30-70",
    "80-120": "80-120"
  },
  "multiThemes": {
    "multiplication": "Multiplication",
    "division": "Division",
    "squaring": "Squaring"
  },
  "cardsDifficulties": {
    "0-4": "0-4",
    "0-9": "0-9"
  }
}